import { render, staticRenderFns } from "./Developers.vue?vue&type=template&id=2410b230&scoped=true"
import script from "./Developers.vue?vue&type=script&lang=js"
export * from "./Developers.vue?vue&type=script&lang=js"
import style0 from "./Developers.vue?vue&type=style&index=0&id=2410b230&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2410b230",
  null
  
)

export default component.exports